<template>
  <ECharts :options="optoin" style="width: 100%; height: 100%;" />
</template>

<script>
import ECharts from 'vue-echarts/components/ECharts'
export default {
  components: {
    ECharts
  },
  props: {
    lines: Array
  },
  computed: {
    optoin () {
      return {
        title: {
          text: '查询位置',
          subtext: '国内实时查询位置信息',
          left: 'center',
          textStyle: {
            color: '#fff'
          }
        },
        tooltip: {
          trigger: 'item'
        },
        geo: {
          map: 'china',
          zoom: 1.2,
          label: {
            show: true,
            color: '#6edcfb',
            emphasis: {
              show: false
            }
          },
          itemStyle: {
            normal: {
              // 地图颜色
              areaColor: '#1c2d8c',
              // 边框颜色
              borderColor: '#6edcfb',
              borderWidth: 1.5
            },
            emphasis: {
              // 地图hover颜色
              areaColor: '#78a3c6'
            }
          }
        },
        series: [
          {
            type: 'lines',
            data: this.lines.map(i => ([i[1], i[0]])),
            zlevel: 1,
            effect: {
              show: true,
              period: 2,
              trailLength: 0.7,
              color: '#EBFC08',
              symbolSize: 5,
              symbol: 'arrow'
            },
            lineStyle: {
              normal: {
                color: '#fff',
                width: 1,
                curveness: 0.2,
                opacity: 0.5
              }
            }
          }
        ]
      }
    }
  },
  created () {

  }
}
</script>
